//
//  useCsvExportButton.ts
//
//  isana.net,inc. Proprietary and Confidential
//

import { useMemo } from "react";
import dayjs from "dayjs";

export type CsvExportCommonProps = {
  showMessage: (msg: string, type: "success" | "error") => void;
  startDate: string;
  endDate: string;
  summaryItemIds?: string;
};

type UseCsvExportButton = {
  showMessage: (msg: string, type: "success" | "error") => void;
  startDate: dayjs.Dayjs | null;
  endDate: dayjs.Dayjs | null;
  selectedCsvSummaryItems?: string[];
};

const useCsvExportButton = ({
  showMessage,
  startDate,
  endDate,
  selectedCsvSummaryItems = [],
}: UseCsvExportButton): CsvExportCommonProps => {
  return useMemo(
    () => ({
      showMessage,
      startDate: startDate ? startDate.format("YYYY-MM-DD") : "",
      endDate: endDate ? endDate.format("YYYY-MM-DD") : "",
      ...(selectedCsvSummaryItems &&
        selectedCsvSummaryItems.length > 0 && {
          summaryItemIds: selectedCsvSummaryItems.join(","),
        }),
    }),
    [showMessage, startDate, endDate, selectedCsvSummaryItems]
  );
};

export default useCsvExportButton;
